import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/landing/Hero";
import ProofBanner from "@/components/landing/ProofBanner";
import HowItWorks from "@/components/landing/HowItWorks";
import CaseStudy from "@/components/landing/CaseStudy";
import Pricing from "@/components/landing/Pricing";
import Faq from "@/components/landing/Faq";

const Landing = () => (
    <div className="min-h-screen bg-[#FAF9F6] text-foreground">
        <Header />
        <Hero />
        <ProofBanner />
        <HowItWorks />
        <CaseStudy />
        <Pricing />
        <Faq />
        <Footer />
    </div>
);

export default Landing;
